/**
 * Translation key of every fixed user-facing string of the What's New modal, in the
 * `onboarding/whats-new` catalog. The values are keys, not copy: the modal resolves them with the
 * `transloco` pipe and the stark engine through {@link resolveWhatsNewLabel}, so they follow the
 * active language.
 */
export const WHATS_NEW_STRINGS = {
  title: 'onboardingWhatsNew.title',
  introSubtitle: 'onboardingWhatsNew.introSubtitle',
  next: 'onboardingWhatsNew.next',
  prev: 'onboardingWhatsNew.prev',
  done: 'onboardingWhatsNew.done',
  startTour: 'onboardingWhatsNew.startTour',
  skip: 'onboardingWhatsNew.skip',
  close: 'onboardingWhatsNew.close',
  learnMore: 'onboardingWhatsNew.learnMore',
  unread: 'onboardingWhatsNew.unread',
  empty: 'onboardingWhatsNew.empty',
  dialogLabel: 'onboardingWhatsNew.dialogLabel',
} as const;

/** Key of a What's New string. */
export type WhatsNewStringKey = keyof typeof WHATS_NEW_STRINGS;
